import './App.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider } from './constants/providers/AuthProvider';
import { StripeProvider } from './providers/StripeProvider';
import { AuthenticatedLayoutWrapper } from './components/layout/AuthenticatedLayoutWrapper';
import { RouteRenderer, routeDefinitions } from './routing';

// Create QueryClient outside component for stability
// This ensures it's available immediately and doesn't cause re-render issues
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // Don't retry aborted queries - these are expected when React Query cancels queries
      retry: (failureCount, error) => {
        // Don't retry on AbortErrors - these are expected when queries are canceled
        if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <StripeProvider>
          <Router>
            <AuthenticatedLayoutWrapper>
              <RouteRenderer routes={routeDefinitions} />
            </AuthenticatedLayoutWrapper>
          </Router>
        </StripeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
